import React from 'react';
import { components, OptionProps } from 'react-select';
import styled from 'styled-components';
import { Tooltip } from 'src/common/Tooltip';

const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export interface HintableOption {
  label: string;
  value: string;
  hint?: string;
}

export const OptionWithHint: React.FC<OptionProps<HintableOption, false>> = (props) => {
  const { data, children } = props;

  if (data.hint) {
    return (
      <components.Option {...props}>
        <OptionWrapper>
          <span>{children}</span>
          <Tooltip
            dataId={`select-option-${data.value}`}
            dataHtml={data.hint}
            place="right"
            positionStrategy="fixed"
            infoIconStyle={{ transform: 'scale(0.8)' }}
          />
        </OptionWrapper>
      </components.Option>
    );
  }

  return <components.Option {...props} />;
};
